import { UserProfile } from './User.types';

export const initialState: UserProfile = {
  allowSaveWithoutTeam: false,
  applicationUserId: '',
  block_alerts: false,
  enabled: false,
  first_name: '',
  font_size_multiplier: 0,
  isDragonflyUser: false,
  // This toggle is taken into consideration only for FPA and ignored for XPA
  isGenAiP2pPaClinicalSummaryEnabled: false,
  isXsolisUser: false,
  last_name: '',
  main_organization_id: '',
  main_organization_name: '',
  phone_number: '',
  use_auto_save: false,
  user_roles: [],
  user_teams: [],
  user_type_id: 0,
  username: '',
};

export const USER_ROLES = {
  ADMINISTRATOR: 2,
  AUDITOR: 9,
  MID_LEVEL_REVIEWER: 5,
  PHYSICIAN_ADVISOR: 4,
  SUPPORT: 8,
  SYSTEM_ADMINISTRATOR: 1,
  TEAM_LEAD: 3,
  TRAINEE: 7,
  TRAINER: 6,
};

export const XSOLIS_USER_TYPE = 1;
